export default __webpack_public_path__ + "images/1f167a4d61f9efd47bd98a9cb591f292-comics.jpg";